import React, { useState } from 'react';
import { siteConfig } from '../siteData';
import { useTeachers } from '../hooks/sectionHooks';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { LoadingBoundary } from '../components/LoadingSpinner';
import '../App.css';

function Teachers() {
  const { data: teachersData, isLoading } = useTeachers();
  const displayTeachers = Array.isArray(teachersData) && teachersData.length > 0 ? teachersData : siteConfig.teachers;
  
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const teachersPerPage = 4;
  const totalPages = Math.ceil((displayTeachers?.length || 0) / teachersPerPage);
  
  // Get current page teachers
  const indexOfLastTeacher = currentPage * teachersPerPage;
  const indexOfFirstTeacher = indexOfLastTeacher - teachersPerPage;
  const currentTeachers = displayTeachers?.slice(indexOfFirstTeacher, indexOfLastTeacher) || [];

  // Helper function to truncate bio to 500 characters
  const truncateBio = (bio) => {
    if (!bio) return '';
    if (bio.length <= 500) return bio;
    return bio.substring(0, 500) + '...';
  };

  // Check if bio needs truncation
  const needsTruncation = (bio) => {
    return bio && bio.length > 500;
  };

  // Page navigation handlers
  const goToPage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App agents-page">
      <Header />

      {/* Main Content */}
      <main className="agents-main">
        <h1 className="agents-title">Багш нар</h1>
        
        <LoadingBoundary isLoading={isLoading}>
          <div className="agents-list">
            {currentTeachers?.map((teacher) => (
              <div key={teacher.id} className="agent-card">
                <div className="agent-image-container">
                  <img
                    src={teacher.image}
                    alt={teacher.name}
                    className="agent-image"
                  />
                </div>
                <div className="agent-content">
                  <div className="agent-header">
                    <div className="agent-info">
                      <h2 className="agent-name">{teacher.name}</h2>
                      <p className="agent-role">{teacher.title}</p>
                    </div>
                    {needsTruncation(teacher.bio) && (
                      <button
                        className="see-full-bio-btn"
                        onClick={() => setSelectedTeacher(teacher)}
                      >
                        See full bio
                      </button>
                    )}
                  </div>

                  {teacher.bio && (
                    <div className="agent-about">
                      <h3 className="agent-section-title">Танилцуулга</h3>
                      <div className="agent-bio" dangerouslySetInnerHTML={{ __html: truncateBio(teacher.bio) }}></div>
                    </div>
                  )}

                  {(teacher.experience || teacher.education) && (
                    <div className="agent-details">
                      <h3 className="agent-section-title">Мэдээлэл</h3>
                      <div className="agent-info-grid">
                        {teacher.experience && (
                          <span className="agent-info-item">• Туршлага: {teacher.experience}</span>
                        )}
                        {teacher.education && (
                          <span className="agent-info-item">• Боловсрол: {teacher.education}</span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

        </LoadingBoundary>

        {/* Pagination */}
        {!isLoading && totalPages > 1 && (
          <div className="pagination">
            <button 
              className="pagination-arrow"
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lt;
            </button>
            
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
              // Show first page, last page, current page, and pages around current
              if (
                page === 1 || 
                page === totalPages || 
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <button
                    key={page}
                    className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                );
              } else if (page === currentPage - 2 || page === currentPage + 2) {
                return <span key={page} className="pagination-dots">...</span>;
              }
              return null;
            })}
            
            <button 
              className="pagination-arrow"
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &gt;
            </button>
          </div>
        )}
      </main>

      <Footer />

      {/* Bio Modal */}
      {selectedTeacher && (
        <div className="bio-modal-overlay" onClick={() => setSelectedTeacher(null)}>
          <div className="bio-modal" onClick={(e) => e.stopPropagation()}>
            <button className="bio-modal-close" onClick={() => setSelectedTeacher(null)}>
              ×
            </button>
            <div className="bio-modal-header">
              <div className="bio-modal-image">
                <img src={selectedTeacher.image} alt={selectedTeacher.name} />
              </div>
              <div className="bio-modal-info">
                <h2 className="bio-modal-name">{selectedTeacher.name}</h2>
                <p className="bio-modal-title">{selectedTeacher.title}</p>
              </div>
            </div>
            <div className="bio-modal-content">
              <h3 className="bio-modal-section-title">Танилцуулга</h3>
              <div 
                className="bio-modal-text" 
                dangerouslySetInnerHTML={{ __html: selectedTeacher.bio }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Teachers;
